var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"role":"presentation"}},[_c('SearchWidget'),_vm._v(" "),_c('a',{staticClass:"header__logo-link",attrs:{"href":"/"}},[_c('HeaderLogo')],1),_vm._v(" "),_c('SiteNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }